import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IPasswordResetVerifyDto,
  IPasswordResetVerifyResponse,
} from "./types";

const postApis = createPostApi<
  IApiResponse<IPasswordResetVerifyResponse>,
  IPathBaseParam,
  IPasswordResetVerifyDto
>("auth.passwordReset.verify");

export const verify = {
  ...postApis,
};
